import config from 'config';
import Keycloak, { KeycloakInitOptions } from 'keycloak-js';
import React from 'react';
import { IAuthContextProps, keycloakContext } from './keycloakContext';
import type { KeycloakAuthProviderProps } from './interfaces';

const defaultOptions: KeycloakInitOptions = {
  onLoad: 'check-sso',
};

const keycloakClient = new Keycloak({
  url: config.authentication.authority_url,
  realm: window.location.pathname.split('/')[1],
  clientId: config.authentication.client_id,
});

function createAuthProvider(AuthContext: React.Context<IAuthContextProps>) {
  const KeycloakAuthProvider: React.FC<KeycloakAuthProviderProps> = ({
    client = keycloakClient,
    children,
    initOptions,
  }) => {
    const [initialized, setInitialized] = React.useState<boolean>(false);
    const token = localStorage.getItem('kc_token');
    const refreshToken = localStorage.getItem('kc_refreshToken');

    React.useEffect(() => {
      const initialize = () => {
        client
          .init({ ...defaultOptions, ...initOptions, token, refreshToken })
          .then(() => {
            setInitialized(true);
            localStorage.setItem('kc_token', client.token);
            localStorage.setItem('kc_refreshToken', client.refreshToken);
          })
          .catch((err) => {
            localStorage.clear();
            client.logout();
            initialize();
            console.log(err);
          });
      };
      if (!window.location.pathname.includes('/logout')) {
        initialize();
      }
    }, []);

    return <AuthContext.Provider value={{ initialized, client }}>{children}</AuthContext.Provider>;
  };

  return KeycloakAuthProvider;
}

const KeycloakProvider = createAuthProvider(keycloakContext);
export const KeycloakConsumer = keycloakContext.Consumer;
export default KeycloakProvider;
